import { render } from "./Newsletter.vue?vue&type=template&id=2d44716a&scoped=true"
const script = {}

import "./Newsletter.vue?vue&type=style&index=0&id=2d44716a&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d44716a"]])

export default __exports__